<template>
  <div class="ChatCQU_sci">
    <comHeader
      :active="active"
      :value="value"
      style="background-color: rgba(49, 89, 161, 1); border: none"
    ></comHeader>
    <div class="main_body">
      <div class="main_top">
        <div class="main_sear">
          <div class="sea_tit">
            <img
              style="width: 30px"
              src="../../assets/img/ChatLibrary-logo.png"
              alt=""
            />
            <div class="sea_txt">ChatArchives | 期刊回溯文献发现 / 引用</div>
          </div>
          <div class="sea_box">
            <div class="sea_tab">
              <div class="switch" @click="switchType_operate">
                <!-- <img
                  src="@/assets/img/u103.svg"
                  style="vertical-align: middle"
                />
                <span v-if="switchType === 1">切换传统检索</span>
                <span v-else>切换语义检索</span> -->
              </div>
            </div>
            <div
              class="sea_s"
              v-if="switchType === 1"
              style="margin: 20px 0 0 0"
            >
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入内容"
                v-model="textarea"
                class="custom-textarea"
                style="overflow: hidden; resize: none"
              >
              </el-input>
              <div
                class="btn_sea"
                :style="
                  corpus_or
                    ? 'justify-content: space-between;'
                    : 'justify-content: flex-end;'
                "
              >
                <div
                  class="btn_sea_ jour_s"
                  v-if="corpus_or"
                  style="position: relative; top: 5px; margin: 0 0 0 10px"
                >
                  选择期刊范围:&ensp;<el-select
                    size="small"
                    style="width: 150px; text-align: center"
                    v-model="corpus_val"
                    placeholder="请选择"
                    multiple
                    collapse-tags
                    @change="corpus_sel"
                  >
                    <el-option
                      v-for="item in corpus_list"
                      :key="item.code"
                      :label="item.tag"
                      :value="item.code"
                      :disabled="
                        corpus_val.length == 1 &&
                        corpus_val.indexOf(item.code) > -1
                      "
                      style="text-align: center"
                    >
                    </el-option>
                  </el-select>

                  <!-- <el-popover placement="bottom" width="145" trigger="hover">
                    <el-table :data="gridData">
                      <el-table-column
                        width="150"
                        property="date"
                        label="日期"
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        property="name"
                        label="姓名"
                      ></el-table-column>
                      <el-table-column
                        width="300"
                        property="address"
                        label="地址"
                      ></el-table-column>
                    </el-table>
                    <el-button slot="reference" >click 激活</el-button>
                    <div class="sel_btn_">
                      {{}}
                    </div>
                  </el-popover> -->
                </div>
                <div class="btn_sea_">
                  <el-radio v-model="radio" label="1">检索摘要</el-radio>
                  <el-radio v-model="radio" label="2">检索全文</el-radio>
                  <i
                    @click="search_"
                    class="el-icon-search custom-icon"
                    style="font-size: 21px"
                  ></i>
                </div>
              </div>
            </div>
            <div class="sea_s_" v-else>
              <div
                class="sea_sel"
                v-for="(item, index) in listQuery"
                :key="index"
              >
                <i
                  v-if="index == 0"
                  class="el-icon-circle-plus-outline"
                  style="color: #39a7b4; font-size: 28px"
                  @click="add_sea()"
                ></i>
                <i
                  v-else
                  class="el-icon-remove-outline"
                  style="color: #39a7b4; font-size: 28px"
                  @click="delete_sea(index)"
                ></i>
                <el-select
                  class="sel_"
                  v-if="index > 0"
                  style="width: 145px"
                  v-model="item.state"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in option_state"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-select
                  class="sel_"
                  :style="
                    index == 0
                      ? 'width:305px'
                      : 'width:145px;margin: 0 10px 0 0;'
                  "
                  v-model="item.type"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in option_type"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input
                  class="sel_"
                  :class="index == 0 ? 'sel_0' : ''"
                  v-model="item.value"
                  placeholder=""
                >
                  <i
                    v-if="index == 0"
                    slot="suffix"
                    class="el-icon-search custom-icon"
                    style="font-size: 21px"
                  ></i
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <img class="img_ai" src="../../assets/img/home_img/u11.png" alt="" />
      </div>
    </div>

    <div class="box">
      <div class="box_tit">
        <img src="../../assets/img/home_img/u49.png" alt="" />
        <div class="tit_txt">平台介绍 Platform profile</div>
      </div>
      <div class="box_txt">
        <p>
          AI技术不仅正在改变着人们的日常生活，同时也为传统的出版行业带来了革命性的变革。ChatJournals是专注于期刊杂志社的AI智能服务，集成了多项先进的人工智能技术，能够为学术出版领域带来前所未有的创新与便利。
        </p>
        <p>
          结合先进AI技术的集成与应用，ChatJournals能够为学术出版机构、学术刊物编辑部、专业学协会等机构提供集智能咨询、读者服务、学术推送、宣传推广等于一体的智能服务。提高工作效率，注入创新动力，助力学术影响力的提升，为学术出版注入全新的活力与创新动力。
        </p>
      </div>
      <div class="box_img">
        <img class="bac_img" src="@/assets/img/u11.png" width="683px" />
        <img
          class="bac_img_con"
          src="../../assets/img/home_img/research2.png"
          alt=""
        />
      </div>
      <ComFooter></ComFooter>
    </div>
  </div>
</template>
  
<script>
import { journalFellowApi, fellowSimilarApi1 } from "@/api/classify";
import comHeader from "@/components/ComHeader.vue";
import ComFooter from "@/components/ComFooter_one.vue";
import store from "@/store";
export default {
  components: { ComFooter, comHeader },
  data() {
    return {
      active: 9,
      value: "ChatArchives",
      switchType: 1,
      searchType: "all",
      textarea: "",
      radio: "1",
      option_type: [
        {
          value: "title",
          label: "标题",
        },
        {
          value: "work",
          label: "关键词",
        },
        {
          value: "year",
          label: "年份",
        },
      ],
      option_state: [
        {
          value: "and",
          label: "AND",
        },
        {
          value: "or",
          label: "OR",
        },
        {
          value: "not",
          label: "NOT",
        },
      ],
      listQuery: [
        { type: "title", value: "", state: "and" },
        { type: "title", value: "", state: "and" },
      ],
      corpus_or: false,
      corpus_list: [],
      corpus_val: [],
    };
  },
  created() {
    if (
      store.getCookie("organ_name") == "辽宁根谷智能科技服务有限公司" &&
      sessionStorage.getItem("corpus_s")
    ) {
      this.corpus_or = true;
      this.corpus_list = JSON.parse(sessionStorage.getItem("corpus_s"));
      // let all_corpus = {
      //   tag:'全部',
      //   code:'all'
      // }
      // this.corpus_list = [all_corpus, ...this.corpus_list];
      // this.corpus_val = this.corpus_list[0].code;
      console.log(this.corpus_list);
      this.corpus_val = this.corpus_list.map((item) => item.code);
      console.log(this.corpus_val.indexOf(this.corpus_val[0]));
    }
  },
  methods: {
    switchType_operate() {
      if (this.switchType === 1) {
        // 语义检索
        this.searchType = "result";
        this.switchType = 2;
      } else {
        // 传统逻辑检索
        this.searchType = "all";
        this.switchType = 1;
      }
    },
    // 添加检索条件
    add_sea() {
      const some_null = this.listQuery.some(
        (item) => item.value === "" || item.value === null
      );

      if (some_null) {
        this.$message({
          message: this.$t("chatresearch.inputTips"),
          type: "warning",
        });
      } else {
        this.listQuery.push({ type: "title", value: "", state: "and" });
      }
    },
    // 删除检索条件
    delete_sea(i) {
      if (i > 0) {
        this.listQuery.splice(i, 1);
      }
    },
    search_() {
      if (this.switchType == 1) {
        let cqu_copy = {
          page: 1,
          size: 10,
          year: [],
          author: [],
          content: this.textarea,
          show_type: "",
          keyword: [],
          article_content: "",
          corpus_ids: this.corpus_val,
        };
        this.$router.push({
          path: "/chatArchivesList",
          query: {
            radio: this.radio,
            cqu: JSON.stringify(cqu_copy),
          },
        });
      } else {
      }
    },
    corpus_sel(event) {
      console.log(event);
    },
  },
};
</script>
  
<style lang='less' scoped>
.ChatCQU_sci {
  height: 100vh;
  //   position: relative;
  //   //   padding: 20px 0;
  //   background-image: url("../../assets/img/背景图/小助手-05(1).jpg");
  //   background-size: cover;
  //   background-position: center center;
}

.ChatCQU_sci {
  // padding: 20px 0 0 0 ;
  // // width: 100%; height: 100vh;
  // background: url("../../assets/img/背景图/小助手-05(1).jpg")  no-repeat;
  // background-size: 100% 100%;
  // background-attachment: fixed;
}

.box {
  margin: 25px auto;
  width: 80%;
  max-width: 1000px;

  .box_tit {
    display: flex;
    align-items: center;
    justify-content: center;
    .tit_txt {
      margin: 0 0 0 10px;
      font-size: 25px;
      font-weight: 600;
    }
  }
  .box_txt {
    margin: 10px 0;
    text-indent: 2em;
    line-height: 28px;
    text-align: left;
    p {
      margin: 5px 0;
    }
  }
  .box_img {
    padding: 20px 0;
    height: 520px;
    img {
      width: 90%;
    }
  }
}

.main_body {
  // padding: 20px;
  //   margin: 20px;
  //   margin-top: 0;
  //   height: 300px;
  //   padding: 30px 0;

  background-color: rgba(49, 89, 161, 1);
}
.main_top {
  width: 80%;
  max-width: 1100px;
  //   width: 1100px;
  min-height: 299px;
  margin: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  .img_ai {
    width: 520px;
  }
}
.main_sear {
  position: absolute;
  left: 0;
  width: 700px;
  // margin: 20px 0 0 0;
  .sea_tit {
    display: flex;
    align-items: center;
    .sea_txt {
      color: white;
      font-weight: 600;
      font-size: 24px;
      margin: 0 0 0 12px;
    }
  }
  .sea_box {
    width: 100%;
    // height: 200px;
  }
  .sea_tab {
    display: flex;
    justify-content: flex-end;
    margin: 0px 0 5px 0;
  }
}
.switch {
  color: #e6a23c;
  cursor: pointer;
  img {
    margin-right: 5px;
    vertical-align: middle;
    height: 20px !important;
  }
  span {
    margin: 0;
  }
}
.switch:hover {
  // color: #81602e;
}
/deep/ .custom-textarea .el-textarea__inner {
  background-color: rgba(255, 255, 255, 0.8);
  scrollbar-width: thin;
  scrollbar-color: #888 #f0f0f0;
  resize: none;
  border-start-end-radius: 4px;
  border-start-start-radius: 4px;
  border-end-end-radius: 0px;
  border-end-start-radius: 0px;
  border-color: transparent; /* 取消边框 */
}
/deep/ .custom-textarea .el-input__inner:focus {
  border-color: transparent; /* 焦点时也取消边框 */
}

/deep/ .custom-textarea .el-textarea__inner::-webkit-scrollbar {
  width: 5px;
  border-radius: 20px;
  //   background-color: rgb(199, 78, 78);
}

/deep/ .custom-textarea .el-textarea__inner::-webkit-scrollbar-thumb {
  background-color: #888;
  border: 4px solid transparent;
  //   background-clip: padding-box;
  border-radius: 12px;
}
// /deep/ .custom-textarea textarea {
//   overflow: hidden !important; /* 禁用滚动条 */
//   resize: none; /* 禁止用户手动调整文本框的尺寸 */
//   height: auto !important; /* 强制将高度设置为自适应 */
//   max-height: none !important; /* 禁用最大高度限制 */
// }
.btn_sea {
  background: rgba(255, 255, 255, 0.8);
  padding: 5px 20px 10px 0;
  border-end-end-radius: 4px;
  border-end-start-radius: 4px;
  display: flex;
  justify-content: flex-end;
  // justify-content: space-between;
  align-items: center;

  /deep/ .el-radio__inner {
    width: 12px;
    height: 12px;
  }
  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: rgba(54, 54, 54, 0.8);
  }
  /deep/ .el-radio__inner::after {
    background-color: rgb(63, 63, 63);
  }
  /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: rgba(255, 255, 255, 0.8);
    background: rgba(255, 255, 255, 0.8);
  }
}
.custom-icon {
  cursor: pointer;
  font-size: 21px;
  background: linear-gradient(
    45deg,
    #ff3333,
    #3352ff
  ); /* 设置渐变色，可以根据需要调整颜色和角度 */
  -webkit-background-clip: text; /* 使用 Webkit 前缀来启用背景色填充文本 */
  background-clip: text; /* 启用背景色填充文本 */
  -webkit-text-fill-color: transparent; /* 隐藏文本颜色 */
  display: inline-block; /* 使渐变色填充整个图标 */
}
.sea_s_ {
  min-height: 153px;
}
.sea_sel {
  display: flex;
  align-items: center;
  margin: 0 0 20px 0;
}
.sel_ {
  margin: 0 10px;
  /deep/ .el-input__inner {
    border-radius: 20px;
    background: #d6deec;
    border-color: transparent;
  }
  /deep/ .el-input__inner:focus {
    border-color: transparent; /* 焦点时也取消边框 */
  }
  /deep/ .el-input__suffix {
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/ .el-input__suffix-inner {
    display: inline-block;
  }
}
.sel_0 {
  /deep/ .el-input__inner {
    padding-right: 40px !important;
  }
}
.bac_img {
  width: 635px !important;

  right: 122px !important;
}
.bac_img_con {
  width: 550px !important;
  height: 330px !important;
  position: relative;
  top: -445px;
}
.jour_s {
  // margin: 10px 0;
  /deep/ .el-input__inner {
    text-align: center;
  }
  /deep/ .el-tag__close {
    display: none !important; /* 隐藏删除按钮 */
  }
  /deep/ .el-select__tags-text {
    max-width: 60px;
    white-space: nowrap; //文本强制不换行；
    text-overflow: ellipsis; //文本溢出显示省略号；
    overflow: hidden; //溢出的部分隐藏；
  }
}
</style>